export const mockRoles = [
  { id: 'r1', title: 'Senior Frontend Engineer', department: 'Engineering', status: 'Active', applicants: 42, target: 1, daysOpen: 14 },
  { id: 'r2', title: 'Product Marketing Manager', department: 'Marketing', status: 'Active', applicants: 18, target: 2, daysOpen: 5 },
  { id: 'r3', title: 'Data Scientist (AI/ML)', department: 'Data', status: 'Urgent', applicants: 89, target: 1, daysOpen: 21 },
  { id: 'r4', title: 'UX Researcher', department: 'Design', status: 'Paused', applicants: 12, target: 1, daysOpen: 30 },
];

export const pipelineStages = ['Sourced', 'Applied', 'Screening', 'Interviewing', 'Offer'];

export const mockCandidates = [
  { id: 'c1', name: 'Alex Vance', role: 'r1', stage: 'Interviewing', score: 92, status: 'On Track', email: 'alex.v@example.com', tech: ['React', 'TypeScript', 'WebGL'] },
  { id: 'c2', name: 'Sarah Chen', role: 'r3', stage: 'Sourced', score: 88, status: 'Action Needed', email: 'schen.data@example.com', tech: ['Python', 'TensorFlow', 'SQL'] },
  { id: 'c3', name: 'Marcus Johnson', role: 'r1', stage: 'Applied', score: 75, status: 'Pending Review', email: 'mjohnson.dev@example.com', tech: ['Vue', 'JavaScript', 'CSS'] },
  { id: 'c4', name: 'Elena Rostova', role: 'r2', stage: 'Offer', score: 96, status: 'Awaiting Signature', email: 'erostova@example.com', tech: ['HubSpot', 'Figma', 'Copywriting'] },
  { id: 'c5', name: 'David Kim', role: 'r1', stage: 'Screening', score: 81, status: 'Scheduled', email: 'dkim.codes@example.com', tech: ['React Native', 'Redux', 'Node'] },
  { id: 'c6', name: 'Priya Patel', role: 'r3', stage: 'Interviewing', score: 94, status: 'Top Pick', email: 'ppatel.ai@example.com', tech: ['PyTorch', 'AWS', 'C++'] },
];

export const upcomingInterviews = [
  { id: 'i1', candidateId: 'c1', type: 'Technical Panel', time: 'Today, 2:00 PM', interviewer: 'Emma W. (Tech Lead)' },
  { id: 'i2', candidateId: 'c5', type: 'HR Screen', time: 'Tomorrow, 10:30 AM', interviewer: 'Jason B. (Recruiter)' },
];

export const demoFaqs = [
  { 
    q: "How do I setup my first recruitment role?", 
    a: "Navigate to the 'Radar Home' and click '+ New Requisition'. RecruitRay's AI will automatically suggest scoring weights based on your job description." 
  },
  { 
    q: "Is the sample data persistent?", 
    a: "No, this is a simulated demo environment. Any changes you make will reset upon refreshing the browser." 
  },
  { 
    q: "Can I invite my team to collaborate on scorecards?", 
    a: "Absolutely. RecruitRay supports multi-user feedback loops where technical leads and HR can provide independent ratings that the AI aggregates." 
  },
  { 
    q: "How does the AI Screening Fit Score work?", 
    a: "The score (0-100) is calculated based on skill match density, experience relevance, and historical success patterns from similar hires in your industry." 
  },
  { 
    q: "What privacy measures are in place for candidate data?", 
    a: "RecruitRay uses enterprise-grade encryption. In this demo, all candidate data is entirely fictional and used only for workflow visualization." 
  }
];